// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__ipJ0b","ActionBox":"styles_ActionBox__Ujw-f"};